import { TableRow, TableCell, SvgIcon, Collapse, useTheme, Box, Typography, IconButton } from '@mui/material';
import { Minus, Plus } from '../../../../assets';
import { FC, useState } from 'react';
import { MadeInStoreItem } from '../../../../app/services/api/generated';
import MadeInStoreIngredients from './MadeInStoreIngredients';
import CreateIcon from '@mui/icons-material/Create';
import { useTranslation } from 'react-i18next';

type Props = {
  item: MadeInStoreItem;
  onCreateItem: (item: MadeInStoreItem) => void;
  hasPermissionToWriteMadeInStore: boolean;
}

const MadeInStoreItemRow: FC<Props> = ({ item, onCreateItem, hasPermissionToWriteMadeInStore }) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const theme = useTheme();
  const { t } = useTranslation('recipe');

  const onCreate = () => {
    onCreateItem(item);
  };

  return (
    <>
      <TableRow>
        <TableCell
          sx={{
            cursor: 'pointer',
          }}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            verticalAlign: 'middle',
          }}>
            <SvgIcon>
              {isExpanded ? <Minus /> : <Plus />}
            </SvgIcon>
            <Typography variant='textXS'>
              {item.itemNumber}
            </Typography>
          </Box>
        </TableCell>
        <TableCell variant='clampedText'
          sx={{ minWidth: '160px' }}>
          <Typography variant='textXS'>
            {item.description}
          </Typography>
        </TableCell>
        <TableCell align='center'>
          {Number(item.stockOnHandQuantity).toFixed(2)}
        </TableCell>
        <TableCell align='center'>
          {Number(item.maximumQuantity).toFixed(2)}
        </TableCell>
        {hasPermissionToWriteMadeInStore && <TableCell align='center'
          sx={{ py: 0 }}>
          <IconButton aria-label={t('addItem')}
            size='small'
            onClick={onCreate}
            disabled={(item.maximumQuantity ?? 0) <= 0}
          >
            <CreateIcon />
          </IconButton>
        </TableCell>}
      </TableRow>

      {isExpanded && (
        <>
          <TableRow sx={{
            borderBottom: '3px solid',
            borderTop: '3px solid',
            borderColor: theme.palette.custom.gray[400],
          }}>
            <TableCell colSpan={5}
              sx={{ p: 0, m: 0, border: 0, backgroundColor: theme.palette.common.white }}>
              <Collapse in={isExpanded}>
                <MadeInStoreIngredients
                  ingredients={item.madeInStoreComponents ?? []}
                />
              </Collapse>
            </TableCell>
          </TableRow>
        </>
      )}
    </>
  );
};

export default MadeInStoreItemRow;